import Vue from 'vue';
import moment from 'moment';
import { getValueOfField } from '@/util';

// 콤마 붙이는 필터
Vue.filter('comma', (val) => {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

// 브랜드명 앞에 아이콘 붙이는 필터
Vue.filter('brandListData', (brandId, brandList, type) => {
  if (brandId && brandList && type) {
    const currentBrand = brandList.find((data) => {
      if (data.id === brandId) {
        return data;
      }
    });

    if (type === 'brandIcon') {
      return currentBrand.brandIcon ? `<img src="${currentBrand.brandIcon}" />` : currentBrand.name.toString().charAt(0);
    } else {
      return currentBrand[type];
    }
  }
});

/*
  값 없는 경우에 대한 필터 (default value: '-')
  커스텀이 필요한 경우에만 보여줄 문자를 파라미터로 넘긴다.
*/
Vue.filter('$getEmptyChar', (value, char = '-') => {
  return !value ? char : value;
});

/*
  날짜 관련 필터 (default format: YYYY-MM-DD HH:mm:ss)
  html template에서의 가독성을 위해 dateTime, date, time으로 구분했고 함수 안에서 format을 받아서 변환하는 동작은 동일.
*/
Vue.filter('$getDateTime', (dateTime = '', format = 'YYYY-MM-DD HH:mm:ss') => {
  return dateTime ? moment(dateTime).format(format) : '-';
});

Vue.filter('$getDate', (dateTime = '', dateFormat = 'YYYY-MM-DD') => {
  return dateTime ? moment(dateTime).format(dateFormat) : '-';
});

Vue.filter('$getTime', (dateTime, timeFormat = 'HH:mm:ss') => {
  return dateTime ? moment(dateTime).format(timeFormat) : '-';
});

/*
  객체에서 원하는 키값을 뽑아내는 필터
  ex) {{ obj | $getValueOfField('a.b.c') }}
 */
Vue.filter('$getValueOfField', getValueOfField);



// WEBPACK FOOTER //
// ./src/filters/index.js